import { UploadFailedTag, MediaPreview } from "./mediaPreviewPlugin";
import { EmojiPlugin } from "./emojiPlugin";
import { MentionCustomization } from "./customMention";
const editorPlugins: Array<
  | typeof MediaPreview
  | typeof UploadFailedTag
  | typeof EmojiPlugin
  | typeof MentionCustomization
> = [MediaPreview, UploadFailedTag, EmojiPlugin, MentionCustomization];
export { UploadFailedTag, MediaPreview, EmojiPlugin, MentionCustomization };
export default editorPlugins;
